import { Typography } from "@mui/material";
import HelpArticleLink from "@entrilia/shared/components/HelpArticleLink";
import PortalAccessFooter from "./PortalAccessFooter";
import type { RelatedGuide } from "./portalAccessModel";

interface Props {
  guides: RelatedGuide[];
}

const PortalAccessRelatedGuides = ({ guides }: Props) => {
  if (guides.length === 0) {
    return null;
  }

  return (
    <PortalAccessFooter>
      <Typography variant="caption" color="textSecondary">
        Related guides
      </Typography>
      {guides.map((guide) => (
        <HelpArticleLink key={guide.id} articleId={guide.id} variant="caption">
          {guide.label}
        </HelpArticleLink>
      ))}
    </PortalAccessFooter>
  );
};

export default PortalAccessRelatedGuides;
